module.exports = "img/flags/SX.a959e40.png";